import React from 'react'
import Sales from '../Sales'
import { Link, useLocation, useParams } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { PlaylistAddCheckCircle, PlaylistAddCircle } from '@mui/icons-material';

const SalesMarketing = ({ children }) => {
    const { username } = useParams();
    const location = useLocation();
    const path = location.pathname;
    const split = path.split('/');

    return (
        <Sales>
            <Toaster position="top-center" />
            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="sub-menu">
                            <ul>
                                <li>
                                    <Link to={`/${username}/sales/marketing/data`} className={` sub-menu-item ${split[4] === 'data'? 'active' : ''} `}>
                                        <div className="me-2">
                                            <PlaylistAddCircle />
                                        </div>
                                        <span>Data Penjualan</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${username}/sales/marketing/form`} className={` sub-menu-item ${split[4] === 'form'? 'active' : ''} `} >
                                        <div className="me-2">
                                            <PlaylistAddCheckCircle />
                                        </div>
                                        <span>Kasir Penjualan</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${username}/sales/marketing/tempo`} className={` sub-menu-item ${split[4] === 'tempo'? 'active' : ''} `} >
                                        <div className="me-2">
                                            <PlaylistAddCheckCircle />
                                        </div>
                                        <span>Tempo</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            { children }
        </Sales>
    )
}

export default SalesMarketing
